import {createSelector} from 'reselect';
import {getPriceDetails} from './priceDetails';

const getBookingUrl = createSelector(
    [getPriceDetails],
    (graphqlPriceDetails) => graphqlPriceDetails.checkoutUrl || null
);

export default getBookingUrl;
export {getBookingUrl};
